import React, { useState, useEffect } from 'react';
import {
    createStyles, Theme, makeStyles,
} from '@material-ui/core/styles';
import Modal from '../../../styled-base/modal';
import Button from '../../../styled-base/button';
import KrService from '../../services/kr.service';
import { imgUrl } from '../../../utils/url';
import { useTranslation } from 'react-i18next';
import './style.scss';

type TargetItem = {
  id: string,
  name: string,
}

type Props = {
  metricId: string,
  goalName: string,
  source: string,
  updateKrTargetHit: Array<TargetItem>,
  metricParams: any,
}

const service = new KrService();

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        minHeight: 205,
    },
    img: {
        width: '100%',
    },
    wrapper: {
        padding: '10px 15px',
        textAlign: 'center',
    },
    message: {
        fontSize: 25,
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontStretch: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#2c9ab7',
    },
    goalName: {
        fontSize: 14,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontStretch: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#434957',
    },
    confrim_msg: {
        fontSize: 16,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontStretch: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#212529',
    },
}));

const addPortalClass = () => {
    const element = document.getElementById('app-portal-container');
    if (element) {
        element.setAttribute('class', 'portal-krstop-update-modal-wrapper');
    }
}

const removePortalClass = () => {
    const element = document.getElementById('app-portal-container');
    if (element) {
        element.removeAttribute('class');
    }
}

const KRStopUpdateModal = (props: Props) => {
    const {
        metricId,
        goalName,
        source,
        updateKrTargetHit = [],
        metricParams = {},
    } = props;
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [stopKRData, setStopKRData] = useState<Props>(props);
    const { t } = useTranslation()

    useEffect(() => {
        if (!isOpen) {
            console.log('is open kr stop update modal');
            setIsOpen(true);
            addPortalClass();
            setStopKRData(props);
        }
    }, [props]);

    const closeModal = () => {
        removePortalClass();
        setIsOpen(false);
    }
    const afterSave = () => {
        if (source === 'goalDetails') {
            closeModal();
            if (typeof metricDataSaveAfterAjax === 'function') {
                metricDataSaveAfterAjax(undefined, undefined, metricParams);
            }
        } else if (source === 'fullUpdate') {
            const filterdTargetHits = stopKRData.updateKrTargetHit.filter(m => m.id != stopKRData.metricId);
            if (filterdTargetHits.length > 0) {
                setStopKRData({
                    ...stopKRData,
                    metricId: filterdTargetHits[0].id,
                    goalName: filterdTargetHits[0].name,
                    updateKrTargetHit: filterdTargetHits,
                });
            } else if (typeof updateKeyResultsMenu !== undefined
          && updateKeyResultsMenu && updateKeyResultsMenu != '') {
                closeModal();
                return triggerLeftMenu(
                    window.location.href,
                    updateKeyResultsMenu,
                    undefined,
                    validateKrLink,
                );
            } else {
                closeModal();
                const goalsUrl = ($('#menu-wb-goals') as any).attr('data-url');
                return triggerLeftMenu(
                    goalsUrl,
                    'menu-wb-goals',
                    undefined,
                    validateKrLink,
                );
            }
        }

        return true;
    }
    const onCancel = () => {
        if (!(source === 'fullUpdate' && stopKRData.updateKrTargetHit.length > 0)) {
            closeModal();
        }
        service.saveMetricStatus({ metricId, status: 0 })
            .then((response: any) => {
                afterSave();
            })
            .catch((err: any) => {
                closeModal();
                console.log('Error', err);
            });
    }

    const onYes = () => {
        afterSave();
    }

    return (isOpen && (
        <Modal
            width={600}
            classes="kr-stop-update-modal"
        >
            <Modal.Content>
                <div
                    className={classes.root}
                >
                    <div className="hittng_img">
                        <img
                            src={imgUrl('/images/goal/hitting_target.png')}
                            alt=""
                            className={classes.img}
                        />
                    </div>
                    <div className={classes.wrapper}>
                        <div className={classes.message}>{t('Congratulations on hitting your target!')}</div>
                        <div className={`${classes.goalName} truncateText`}>
                            { (source === 'fullUpdate' ? stopKRData.goalName : '') }
                        </div>
                        <div className={classes.confrim_msg}>
                            {t('Should we continue reminding you to update this key result?')}
                        </div>
                    </div>
                </div>
            </Modal.Content>
            <Modal.Footer>
                <Button type="cancel" isBold={false} onClick={() => onCancel()}>
                    {t('No, I\'m Done!')}
                </Button>
                <Button type="primary" isBold={false} onClick={() => onYes()}>
                    {t('Yes, Continue')}
                </Button>
            </Modal.Footer>
        </Modal>
    ))
}

export default KRStopUpdateModal;
